module.exports = __webpack_public_path__ + "media/left hemicolectomy.7ee1d290.wav";